import { useCallback } from 'react'
import { useHistory } from '@fs/zion-router'
import type { FamilyOrdinancesTab } from '@fs/zion-person-ordinance-view'
import type { PID } from '@fs/zion-tree-types'
import {
  generateOrdinancesFamilyTabUrl,
  type OrdinancesFamilyTabPath,
  useOrdinancesFamilyTabParam,
} from '../../personPageRouteUtil'

const TAB_BY_PATH: Record<OrdinancesFamilyTabPath, FamilyOrdinancesTab> = {
  'parents-siblings': 'parents',
  'spouses-children': 'spouses',
}

const PATH_BY_TAB: Record<FamilyOrdinancesTab, OrdinancesFamilyTabPath | undefined> = {
  parents: 'parents-siblings',
  personal: undefined,
  spouses: 'spouses-children',
}

type UrlTab = {
  /** The family tab the URL names, or undefined on the plain Ordinances URL. */
  urlTab?: FamilyOrdinancesTab
  /** Puts the tab's URL in place of the current one, so the selected tab can be shared as a link. */
  selectTab: (tab: FamilyOrdinancesTab) => void
}

export default function useFamilyOrdinancesUrlTab(pid: PID): UrlTab {
  const history = useHistory()
  const familyTab = useOrdinancesFamilyTabParam()
  const selectTab = useCallback(
    (tab: FamilyOrdinancesTab) => history.replace(generateOrdinancesFamilyTabUrl(pid, PATH_BY_TAB[tab])),
    [history, pid]
  )
  return { urlTab: familyTab && TAB_BY_PATH[familyTab], selectTab }
}
